import { newSpecPage } from '@stencil/core/testing';
import { LabDsChipGroup } from './lab-ds-chip-group';

describe('v4-chip-group', () => {
  it('renders', async () => {
    const page = await newSpecPage({
      components: [LabDsChipGroup],
      html: `<lab-ds-chip-group avatar={true} size="small" />`,
    });
    expect(page.root).toEqualHtml(`
    <lab-ds-chip-group size="small" avatar={true}>
    <mock:shadow-root>
        <div class="chip-group">
        </div>
    </mock:shadow-root>
    </lab-ds-chip-group>
  `);
  });
});
